import { useState } from "react";

import { LoadingOverlay } from "../../components/Loading"
import { NotFound } from "../../components/NotFound";
import { useFetchContatos, useFetchVersoesLiberadas } from "../../services/clientes/useClientes";
import { ColumnSort, ReleasedVersion, ReleasedVersionsFilters } from "../../types/cliente/versoes/types";
import { VersoesLiberadas } from "./VersoesLiberadas"
import { useAuth } from "../../contexts/AuthContext";
import { HistoricoModalContainer } from "./HistoricoModal/HistoricoModalContainer";
import { SortDirection } from "../../components/Table/types";

export enum ModalType {
    CONSULTAR_HISTORICO,
    ENVIAR_RETORNO
}

export const ReleasedVersionsContainer = () => {
    const { oidCliente } = useAuth()


    const [showModal, setShowModal] = useState<boolean | ModalType>(false)
    const [selectedReleasedVersion, setSelectedReleasedVersion] = useState<ReleasedVersion>()
    const [filters, setFilters] = useState<ReleasedVersionsFilters>({
        pagina: 1,
        tamanhoPagina: 10,
    })

    const fecthContactsOptions = useFetchContatos(
        oidCliente ?? 0,
        {
            enabled: !!oidCliente,
            staleTime: Infinity,
        }
    );

    const fetchRelasedVersions = useFetchVersoesLiberadas(
        oidCliente ?? 0,
        filters,
        {
            enabled: !!oidCliente,
        }
    );

    const handlePageChange = (page: number) => {
        setFilters((prev) => ({
            ...prev,
            pagina: page,
        }));
    };

    const handleItemsPerPageChange = (itemsPerPage: number) => {
        setFilters((prev) => ({
            ...prev,
            tamanhoPagina: itemsPerPage,
            pagina: 1,
        }));
    };

    const handleFilter = (newFilters: ReleasedVersionsFilters) => {
        setFilters({
            pagina: 1,
            tamanhoPagina: filters.tamanhoPagina,
            ...newFilters,
        });
    };

    const handleOption = (modalType: ModalType, releasedVersion: ReleasedVersion) => {
        setSelectedReleasedVersion(releasedVersion)
        setShowModal(modalType)
    };


    const onSort = (key: string, direction: SortDirection) => {
        setFilters(prev => ({
            ...prev,
            campoOrdenado: ColumnSort[key.toUpperCase() as keyof typeof ColumnSort],
            sentidoOrdenacao: direction
        }));
    }

    return (
        <>
            {(fetchRelasedVersions.isError || fecthContactsOptions.isError) && (
                <NotFound
                    error={fetchRelasedVersions.error || fecthContactsOptions.error}
                    defaultMessage={fecthContactsOptions.isError ? 'Erro ao carregar a lista de contatos.' : 'Erro ao carregar a lista de versôes liberadas.'}
                    retry={fecthContactsOptions.isError ? fecthContactsOptions.refetch : fetchRelasedVersions.refetch}
                />
            )}
            {(fetchRelasedVersions.isFetching || fecthContactsOptions.isFetching) && <LoadingOverlay />}
            {fetchRelasedVersions.data && fecthContactsOptions.data && <VersoesLiberadas
                contacts={fecthContactsOptions.data}
                data={fetchRelasedVersions.data}
                filters={filters}
                onItemsPerPageChange={handleItemsPerPageChange}
                onPageChange={handlePageChange}
                onFilter={handleFilter}
                handleOption={handleOption}
                onSort={onSort}
            />}

            {selectedReleasedVersion && <HistoricoModalContainer
                onClose={() => setShowModal(false)}
                showModal={showModal === ModalType.CONSULTAR_HISTORICO}
                releasedVersion={selectedReleasedVersion}
            />}
        </>
    )
}